let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dirQ8")).then(() => parcelRequire('lS6bs'));